import {
  faBrain,
  faNotesMedical,
  faHeartbeat,
  faStethoscope,
  faChild,
  faChalkboardTeacher,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function ServicesGrid({ onViewService }) {
  const services = [
    {
      name: 'Mental Health',
      colour: 'border-[#FDD2B7]',
      iconColour: 'bg-[#FDD2B7]',
      textColour: 'text-[#FDD2B7]',
      description:
        'Help with mental health issues, including stress, anxiety, and depression',
      icon: faBrain,
      products: [
        {
          title: 'Counselling',
          bookable: false,
          description:
            'Book a counselling session with a qualified professional.',
          link: 'counselling',
          paymentLink: 'https://buy.stripe.com/test_28E8wP29l93d51Q9yzcbC01',
        },
        {
          title: 'Mindfulness',
          bookable: false,
          description:
            'A programme to help you practice mindfulness and reduce stress.',
          link: 'mindfulness',
        },
        {
          title: 'Relaxation Room Live',
          bookable: false,
          description: 'A live session to help you relax and unwind.',
          link: 'https://schooladvice.co.uk/relaxation-room-live',
          external: true
        },
      ],
    },
    {
      name: 'Health Line',
      colour: 'border-[#E7CDDB]',
      iconColour: 'bg-[#E7CDDB]',
      textColour: 'text-[#E7CDDB]',
      description:
        'Help with minor health issues, including advice on symptoms and conditions.',
      icon: faNotesMedical,
      products: [
        {
          title: 'Nurse Support',
          bookable: false,
          description: 'Speak to a nurse for advice on minor health issues.',
          link: 'nurse-support',
        },
        {
          title: 'GP Services',
          bookable: true,
          description: 'Book a GP appointment for non-urgent conditions.',
          link: 'gp-service',
        },
        {
          title: 'Menopause Support',
          bookable: false,
          description: 'Advice and support from our nurses. Nurses can provide webinars as well as 1-to-1 support',
          link: 'menopause-support',
        },
      ],
    },
    {
      name: 'Physical Health',
      colour: 'border-[#9FB8BE]',
      iconColour: 'bg-[#9FB8BE]',
      textColour: 'text-[#9FB8BE]',
      description:
        'Access to physical health services, including fitness and physiotherapy.',
      icon: faHeartbeat,
      products: [
        {
          title: 'Physiotherapy',
          bookable: false,
          description:
            'Physiotherapy services to support your physical health.',
          link: 'physiotherapy',
        },
        {
          title: 'Ask the PT',
          bookable: false,
          description:
            'Personal training and nutrition guidance from a qualified PT.',
          link: 'https://school-wellbeing.mn.co/plans/1517217?bundle_token=0181ce9b86f504e0d5a7e3d454aabe2f&utm_source=manual',
          external: true,
        },

      ],
    },
    {
      name: 'General Health & Wellbeing',
      colour: 'border-[#C1CCE5]',
      iconColour: 'bg-[#C1CCE5]',
      textColour: 'text-[#C1CCE5]',
      description:
        'Get faster support from clinicians for minor illness or non-urgent conditions.',
      icon: faStethoscope,
      products: [
        {
          title: 'Preparing Parents',
          bookable: false,
          description:
            'A programme to help parents prepare for the arrival of their child.',
          link: 'preparing-parents',
        },
        {
          title: 'Food Intolerance Testing',
          bookable: false,
          description:
            'Testing and guidance for food intolerances and dietary management.',
          link: 'food-intolerance-testing',
        },
        {
          title: 'Financial Wellbeing',
          bookable: false,
          description:
            'Support and resources to help you manage your finances and reduce financial stress.',
          link: 'financial-wellbeing',
        },
      ],
    },
    {
      name: 'Happier Happier You',
      colour: 'border-[#B7DFBC]',
      iconColour: 'bg-[#B7DFBC]',
      textColour: 'text-[#B7DFBC]',
      description:
        'Support for school leaders, including training and development programmes.',
      icon: faChalkboardTeacher,
      products: [
        {
          title: 'HHY Community',
          bookable: false,
          description:
            'Learn more about our awards and programmes to support your school.',
          link: 'https://school-wellbeing.mn.co/plans/1517217?bundle_token=0181ce9b86f504e0d5a7e3d454aabe2f&utm_source=manual',
          external: true
        },
        {
          title: 'Manspace',
          bookable: false,
          description:
            "Support with men's mental and physical health concerns via our nurses and PT.",
          link: 'https://schooladvice.co.uk/manspace',
          external: true
        },
        {
          title: 'SAS Gym',
          bookable: false,
          description:
            'Access to the SAS Gym for physical fitness and wellbeing.',
          link: 'https://school-wellbeing.mn.co/plans/1517217?bundle_token=0181ce9b86f504e0d5a7e3d454aabe2f&utm_source=manual',
          external: true
        },
      ],
    },
    {
      name: 'Pupil Wellbeing',
      colour: 'border-[#F9B6CA]',
      iconColour: 'bg-[#F9B6CA]',
      textColour: 'text-[#F9B6CA]',
      description:
        'Please contact your school for more information about our available pupil wellbeing services.',
      icon: faChild,
      products: [
        // {
        //   title: 'Pupil Yoga',
        //   bookable: false,
        //   description:
        //     'Please contact your school for more information about our pupil yoga programme.',
        //   // link: 'pupil-yoga',
        // },
        // {
        //   title: 'Pastoral Resources',
        //   bookable: false,
        //   description:
        //     'Resources and guidanceces for pupils to support their mental health.',
        //   link: 'pastoral-resources',
        // },
      ],
    },
  ]

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {services.map((service, index) => (
        <div
          key={index}
          className={`bg-white rounded-xl p-4 shadow-md border-l-8 ${service.colour} hover:shadow-lg transition`}
        >
          <div className="flex items-center gap-3 mb-2">
            <div className={`rounded-lg px-3.5 py-2 ${service.iconColour}`}>
              <FontAwesomeIcon icon={service.icon} className="text-[#41264B]" />
            </div>
            <h3 className="text-[#41264B] font-semibold text-lg">
              {service.name}
            </h3>
          </div>
          <p className="text-sm text-[#41264B] mb-4">{service.description}</p>
          {service.products.length > 0 && (<button
            onClick={() => {
              onViewService(service)
            }}
            className="w-full border border-[#B4A6BA] text-[#866393] rounded-lg py-1 hover:bg-violet-50 transition text-sm"
          >
            View Services
          </button> )}
        </div>
      ))}
    </div>
  )
}

export default ServicesGrid
